import React from 'react';
import Icon from '../../../components/AppIcon';

const CorrelationHeatmap = ({ correlationData }) => {
  const getCorrelationColor = (value) => {
    const absValue = Math.abs(value);
    if (absValue >= 0.8) return value > 0 ? 'bg-success text-success-foreground' : 'bg-error text-error-foreground';
    if (absValue >= 0.6) return value > 0 ? 'bg-success/70 text-success-foreground' : 'bg-error/70 text-error-foreground';
    if (absValue >= 0.4) return value > 0 ? 'bg-success/40 text-foreground' : 'bg-error/40 text-foreground';
    if (absValue >= 0.2) return value > 0 ? 'bg-success/20 text-foreground' : 'bg-error/20 text-foreground';
    return 'bg-muted text-muted-foreground';
  };

  const assets = ['EUA', 'Crude Oil', 'Natural Gas', 'Coal', 'Power'];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Asset Correlation Matrix</h3>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={14} />
          <span>Updated 2 min ago</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-full">
          {/* Header row */}
          <div className="grid grid-cols-6 gap-1 mb-1">
            <div className="h-8"></div>
            {assets?.map((asset) => (
              <div key={asset} className="h-8 flex items-center justify-center text-xs font-medium text-muted-foreground">
                {asset}
              </div>
            ))}
          </div>
          
          {/* Data rows */}
          {assets?.map((rowAsset, rowIndex) => (
            <div key={rowAsset} className="grid grid-cols-6 gap-1 mb-1">
              <div className="h-8 flex items-center text-xs font-medium text-muted-foreground pr-2">
                {rowAsset}
              </div>
              {assets?.map((colAsset, colIndex) => {
                const correlationValue = correlationData?.[rowIndex]?.[colIndex];
                return (
                  <div
                    key={`${rowAsset}-${colAsset}`}
                    className={`h-8 flex items-center justify-center text-xs font-medium rounded ${getCorrelationColor(correlationValue)}`}
                    title={`${rowAsset} vs ${colAsset}: ${correlationValue?.toFixed(2)}`}
                  >
                    {correlationValue?.toFixed(2)}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-4 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-success rounded"></div>
            <span className="text-muted-foreground">Positive</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-error rounded"></div>
            <span className="text-muted-foreground">Negative</span>
          </div>
        </div>
        <span className="text-xs text-muted-foreground">Range: -1.00 to +1.00</span>
      </div>
    </div>
  );
};

export default CorrelationHeatmap;